import {InputSelector, InputSelectorProps} from '@/shared-components/InputSelector/InputSelector'

export type ApplicationSelectorProps = InputSelectorProps & {
  applications: string[]
  onValueChanged?: (application: string) => void
}

export const ApplicationSelector = ({applications, onValueChanged, disabled, ...props}: ApplicationSelectorProps) => {
  const isDisabled = disabled || applications.length <= 1

  return (
    <InputSelector {...props} onChange={event => onValueChanged?.(event.target.value)} disabled={isDisabled}>
      {applications.map(application => (
        <option key={application} value={application}>
          {application}
        </option>
      ))}
    </InputSelector>
  )
}
